import { downgradeComponent } from "@angular/upgrade/static";
import { AccountFeatures } from "@app/enum/account/AccountFeature";
import { AuthorizationService } from "@app/services/authorization.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { MaintenanceOverviewComponent } from "./_components/maintenance-overview/maintenance-overview.component";
import { VorVehicleHistoryComponent } from "./_components/vor/vor-vehicle-history/vor-vehicle-history.component";

export class MaintenanceModule {
    static get Dashboard(): string { return 'app.maintenance.dashboard'; }
    static get Overview(): string { return 'app.maintenance.overview'; }
    static get VOR(): string { return 'app.maintenance.vor'; }
    static get TPMS(): string { return 'app.maintenance.tpms'; }
    static get EBPMS(): string { return 'app.maintenance.ebpms'; }

    static get Default(): string { return this.Overview; }
    static get ParentRoot(): string { return "app.maintenance"; }
}

export class Config {

    static $inject = ["$stateProvider"];

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(MaintenanceModule.Dashboard, {
            url: "/dashboard",
            views: { "content@app": { component: "maintenanceDashboard" } },
            data: { translation: "Common.Dashboard" }
        });

        $stateProvider.state(MaintenanceModule.Overview, {
            url: "/overview",
            views: { "content@app": { component: "maintenanceOverview" } },            
            data: { translation: "Common.Overview", subtitleTranslationKey: "MaintenanceOverview.PageDescription" },
        });

        $stateProvider.state(MaintenanceModule.ParentRoot, {
            abstract: true,
            url: "/maintenance",
            redirectTo: MaintenanceModule.Default,
            data: { translation: "Common.Maintenance" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [AccountFeatures.Can, AccountFeatures.Ebpms])]
            }
        })
    }
}

angular
    .module("app.components.maintenance", ["ui.router"])
    .config(Config)

    .directive("maintenanceOverview", downgradeComponent({ component: MaintenanceOverviewComponent }))
    .directive("vorVehicleHistory", downgradeComponent({ component: VorVehicleHistoryComponent }))

    ;